import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Disclosure } from "@headlessui/react";
import { useDocumentTitle } from "@uidotdev/usehooks";
import { useSearchParams } from "react-router-dom";
import { PermissionGate } from "../../routes/PermissionGate";
import { DashboardCard } from "../../ui/Card";
import { UnmatchedDataPointApiDataTableV2 } from "./DatapointApiDataTableV2";
import { UnmatchedDataPointDecisionModal } from "./Modal";

const UnmatchedDataBanner = () => (
    <Disclosure as="div" className="bg-neutral-100 rounded-t border-b px-4">
        {({ open }) => (
            <>
                <div className="py-3 w-full flex items-center text-sm gap-2">
                    <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="h-4 w-4 mr-2 shrink-0 text-ae-blue-550"
                    />
                    <span>
                        These detections were associated with surveys acquired
                        by your company but did not match to a site in AERSHED.
                        They do not appear in the emission event tables.
                    </span>
                    <Disclosure.Button className="text-ae-blue-500 font-bold shrink-0">
                        {open ? "Hide details" : "What does this mean?"}
                    </Disclosure.Button>
                </div>
                <Disclosure.Panel>
                    <hr className="mx-4 py-2" />
                    <div className="w-full px-8 text-sm grid grid-cols-[auto_1fr] items-start gap-x-4 gap-y-3 mb-4">
                        <div className="font-bold text-slate-700">
                            Why it happens
                        </div>
                        <div className="text-slate-600">
                            A site isn't in AERSHED yet or has been marked as
                            inactive with an End Date that is before the date of
                            detection. Alternatively, the detection is outside
                            the matching radius of the sites and may belong to a
                            neighboring operator.
                        </div>
                        <div className="font-bold text-slate-700">
                            What you can do
                        </div>
                        <div className="text-slate-600">
                            Mark the detection as ‘not owned by company’,
                            associate it with an existing site, or report that a
                            site is missing in AERSHED.
                        </div>
                    </div>
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
);

export const UnmatchedData = () => {
    useDocumentTitle("Unmatched Detections - AERSHED");
    // Selected data point, from searchParams
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedDataPoint = searchParams.get("dataPoint");

    return (
        <PermissionGate permission="unmatchedEmissionView">
            <div>
                <DashboardCard>
                    <UnmatchedDataBanner />
                    <UnmatchedDataPointApiDataTableV2
                        onClickRow={(id) =>
                            setSearchParams({ dataPoint: `${id}` })
                        }
                    />
                </DashboardCard>

                {selectedDataPoint && (
                    <UnmatchedDataPointDecisionModal
                        dataPointId={selectedDataPoint}
                        onClose={() => setSearchParams({})}
                    />
                )}
            </div>
        </PermissionGate>
    );
};
